import { render, staticRenderFns } from "./EnvironmentalResponsibilityView.vue?vue&type=template&id=706ddb34&"
import script from "./EnvironmentalResponsibilityView.vue?vue&type=script&lang=js&"
export * from "./EnvironmentalResponsibilityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports